/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";

const Editor = () => {
  const { t: uiT } = useUiTranslation();
  const [showSideBar, setShowSideBar] = useState(false);
  const location = useLocation();
  const { data } = location.state.data;
  const template = location.state.data;
  const user = location.state.user;
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(false);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      className="container-fluid bg-gradient-to-br from-white to-purple-50 min-h-screen"
      dir="rtl"
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div className="px-3" style={{ flex: 1, backgroundColor: "#fbf8fc" }}>
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Affichage des données au début de la page */}
          {data?.id ? (
            <div className="mt-4">
              <div className="rounded border overflow-hidden shadow-sm">
                <iframe
                  title={uiT("ui.editorFrame")}
                  src={`https://foorai.foorweb.store/editor/${data.id}?user=${user}&&selectedProduct=${data.url}`}
                  style={{ width: "100%", height: "1000px", border: "none" }}
                />
              </div>
            </div>
          ) : (
            <div className="mt-4">
              <div className="rounded border overflow-hidden shadow-sm">
                <iframe
                  title={uiT("ui.editorFrame")}
                  src={`https://foorai.foorweb.store/editor/${template.id}?user=${user}&&selectedProduct=${template.url}`}
                  style={{ width: "100%", height: "1000px", border: "none" }}
                />
              </div>
            </div>
          )}

          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Editor;
